import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { ProjectCategory } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("PROJECT_CATEGORY_MODULE");

export const moduleActions = createDataModuleActions<ProjectCategory>(actionCreator);
export const getProjectCategoryTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const projectCategoryActions = {
  ...normalizeActions(moduleActions.data),
};
export const projectCategorysActionCreators = {
  ...moduleActions,
};
